import axios from 'axios';
import router from '../Routes';

export default {
  namespaced: true,
  state: {
    locationtrackings: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: ''
  },
  mutations: {
    RECEIVED_LOCATIONTRACKINGS(state, payload) {
      state.locationtrackings = payload;
      state.isReceiving = false;
    },
    RECEIVING_LOCATIONTRACKINGS(state) {
      state.isReceiving = true;
    },
    LOCATIONTRACKING_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    LOCATIONTRACKING_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    LOCATIONTRACKING_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    LOCATIONTRACKING_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    getLocationTrackingsRequest({dispatch}) {
      dispatch("receivingLocationTrackings");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/locationtrackings';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(response => {
        console.log(response.data);
        response.data.sort((a,b) =>{
          if (b < a) return -1;
          if (a > b) return 1;
          return 0;
        });
        dispatch("receiveLocationTrackings", response.data);
      })
      .catch((error) => {
        console.error(error.response.data);
        //dispatch('loginError', error.response.data.error);
        //this.alertmessage = error.response.data.error;
      });	
    },
    endLocationTracking({commit}){
      commit('LOCATIONTRACKING_DONE');
      router.replace('/login');
    },
    receiveLocationTracking({dispatch}) {
      dispatch('receiveLocationTrackingSuccess');
    },
    receiveLocationTrackings({commit}, payload) {
      commit("RECEIVED_LOCATIONTRACKINGS", payload)
    },
    receivingLocationTrackings({commit}) {
      commit("RECEIVING_LOCATIONTRACKINGS")
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('usertype');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    loginError({commit}, payload) {
      commit('LOCATIONTRACKING_FAILURE', payload);
    },
    resetLocationTracking({commit}) {
      commit('LOCATIONTRACKING_DONE');
    },
    receiveLocationTrackingSuccess({commit}) {
      commit('LOCATIONTRACKING_SUCCESS');
      //router.push('/login');
    },
    requestLocationTracking({commit}) {
      commit('LOCATIONTRACKING_REQUEST');
    },
  }
}
